import { FORM_FIELDS, FORM_FIELDS_NAMES } from '../new-application/new-application-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

export const APP_VIEW_CONTACT_INFO_INPUTS = ({ t }): IFormInputProps[] => [
  {
    key: FORM_FIELDS.FIRST_NAME,
    fieldName: FORM_FIELDS.FIRST_NAME,
    placeholder: t(FORM_FIELDS_NAMES.FIRST_NAME),
    label: t(FORM_FIELDS_NAMES.FIRST_NAME),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: FORM_FIELDS.LAST_NAME,
    fieldName: FORM_FIELDS.LAST_NAME,
    placeholder: t(FORM_FIELDS_NAMES.LAST_NAME),
    label: t(FORM_FIELDS_NAMES.LAST_NAME),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: FORM_FIELDS.EMAIL,
    fieldName: FORM_FIELDS.EMAIL,
    placeholder: t(FORM_FIELDS_NAMES.EMAIL),
    label: t(FORM_FIELDS_NAMES.EMAIL),
    inputType: InputType.Text,
    additionalClasses: 'disabled',
    readOnly: true,
    disabled: true,
    required: true,

  },
  {
    key: FORM_FIELDS.PHONE,
    fieldName: FORM_FIELDS.PHONE,
    placeholder: t(FORM_FIELDS_NAMES.PHONE),
    label: t(FORM_FIELDS_NAMES.PHONE),
    inputType: InputType.Phone,
    defaultCountry: 'US',
    required: true,
  }
];
